import { useEffect, useState } from "react";
import { getData } from "../api";
import { Button } from "@mui/material";

import { Link, useNavigate } from "react-router-dom";

import theme from "../styles/theme";

export default function EvaluationList() {
  const [exercises, setExercises] = useState<any[]>([]);
  const [categories, setCategories] = useState<{ [key: number]: string }>({});
  const navigate = useNavigate(); // Initialisation de `useNavigate`


  useEffect(() => {
    getData("exercises").then((res: any) => {
      setExercises(res.data || []);
    });

    getData("exercise_categories").then((res: any) => {
      const catMap: { [key: number]: string } = {};
      (res.data || []).forEach((cat: any) => {
        catMap[cat.id] = cat.name;
      });
      setCategories(catMap);
    });
  }, []);

  // Group exercises by category
  const groupedExercises: { [key: number]: any[] } = {};
  exercises.forEach((ex) => {
    if (!groupedExercises[ex.category_id]) {
      groupedExercises[ex.category_id] = [];
    }
    groupedExercises[ex.category_id].push(ex);
  });

  return (
    <div
      style={{
        padding: theme.spacing(2),
        maxWidth: 800,
        margin: "0 auto",
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Button
          variant="outlined"
          color="primary"
          onClick={() => navigate("/dashboard")}
          sx={{ marginBottom: 4 }}
        >
          ← Retour au Tableau de bord
        </Button>
      <h1
        style={{
          fontSize: theme.typography.h2.fontSize,
          fontWeight: theme.typography.h2.fontWeight,
          color: theme.palette.primary.main,
          marginBottom: theme.spacing(4),
          fontFamily: theme.typography.fontFamily,
          textAlign: "center",
        }}
      >
        Choisir un exercice
      </h1>

      {Object.entries(groupedExercises).map(([catId, exList]) => (
        <div key={catId} style={{ width: "100%", marginBottom: theme.spacing(4) }}>
          <h2
            style={{
              fontSize: theme.typography.h4.fontSize,
              fontWeight: theme.typography.h4.fontWeight,
              color: theme.palette.secondary.main,
              marginBottom: theme.spacing(2),
              fontFamily: theme.typography.fontFamily,
              textAlign: "left",
            }}
          >
            {categories[Number(catId)] || "Catégorie inconnue"}
          </h2>
          <ul style={{ width: "100%", padding: 0, margin: 0, listStyle: "none" }}>
            {exList.map((e) => (
              <li key={e.id} style={{ marginBottom: theme.spacing(2), width: "100%" }}>
                <Link
                  to={`/evaluation/exercise/${e.id}`}
                  style={{
                    color: theme.palette.background.paper,
                    backgroundColor: theme.palette.primary.main,
                    textDecoration: "none",
                    padding: theme.spacing(1),
                    borderRadius: theme.shape.borderRadius,
                    lineHeight: "55px",
                    display: "block",
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "1.1rem",
                    fontFamily: theme.typography.fontFamily,
                    transition: "background 0.2s",
                    boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
                  }}
                  onMouseOver={(ev) =>
                    (ev.currentTarget.style.backgroundColor = theme.palette.secondary.main)
                  }
                  onMouseOut={(ev) =>
                    (ev.currentTarget.style.backgroundColor = theme.palette.primary.main)
                  }
                >
                  {e.title}
                </Link>
                {e.description && (
                  <div
                    style={{
                      marginTop: theme.spacing(1),
                      color: theme.palette.text.secondary,
                      fontSize: '0.98rem',
                      fontFamily: theme.typography.fontFamily,
                      textAlign: 'center',
                    }}
                  >
                    {e.description}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}

      <style>{`
        @media (max-width: 700px) {
          div[role='main'] {
            padding: 16px !important;
            max-width: 100vw !important;
          }
          ul {
            padding: 0 !important;
          }
          li {
            margin-bottom: 12px !important;
          }
          a {
            font-size: 1rem !important;
            line-height: 44px !important;
          }
        }
      `}</style>
    </div>
  );
}
